import { render, staticRenderFns } from "./PriceFilter.vue?vue&type=template&id=e7fb058e&scoped=true&"
import script from "./PriceFilter.vue?vue&type=script&lang=js&"
export * from "./PriceFilter.vue?vue&type=script&lang=js&"
import style0 from "./PriceFilter.vue?vue&type=style&index=0&id=e7fb058e&lang=scss&scoped=true&"
import style1 from "./PriceFilter.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7fb058e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7fb058e')) {
      api.createRecord('e7fb058e', component.options)
    } else {
      api.reload('e7fb058e', component.options)
    }
    module.hot.accept("./PriceFilter.vue?vue&type=template&id=e7fb058e&scoped=true&", function () {
      api.rerender('e7fb058e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/Filters/PriceFilter.vue"
export default component.exports